import { render, staticRenderFns } from "./PosEditProductService.vue?vue&type=template&id=67ab8f11&scoped=true&"
import script from "./PosEditProductService.vue?vue&type=script&lang=js&"
export * from "./PosEditProductService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab8f11",
  null
  
)

export default component.exports